import * as React from "react"

function SvgLogomark(props) {
  return (
    <svg width={53} height={44} {...props}>
      <g fill={props.fill} fillRule="evenodd">
        <path d="M10.714 37.204V44l16.5-9.421L43.714 44v-6.796L27.214 24z" />
        <path d="M36.063 0l-6.005 3.434-3.344 20.956L46.71 32l6.005-3.434-16.65-9.522zM17.365 0v19.044L.715 28.566 6.72 32l19.994-7.61L23.37 3.434z" />
      </g>
    </svg>
  )
}

export default SvgLogomark
